// extracted by mini-css-extract-plugin
module.exports = {"select":"PageFilter_select__2exUg","extra":"PageFilter_extra__3PkRO","extraContent":"PageFilter_extraContent__2NPfP"};